import { AuthApi } from '@quadminds/client-apis/auth';
import { IAuthMeV2OutputDto } from '@quadminds/shared/auth-system';
import { useMemo } from 'react';
import { UseQueryOptions, useQuery } from 'react-query';

type GetUserInfoQueryOptions = UseQueryOptions<IAuthMeV2OutputDto>;
export const useGetUserInfo = (options?: GetUserInfoQueryOptions) => {
    const authApi = useMemo(() => new AuthApi(), []);
    return useQuery<IAuthMeV2OutputDto>(['getUserinfo'], () => authApi.getUserInfo(), {
        ...options,
    });
};
